/**
 * <product-recommendations>: lazily loads Shopify product recommendations
 * (rendered by the same section via the Section Rendering API) when the
 * section approaches the viewport. Removes itself when there are no results.
 */

class ProductRecommendations extends HTMLElement {
  connectedCallback() {
    if (!this.dataset.url) return;
    this.observer = new IntersectionObserver(
      (entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        this.observer.disconnect();
        this.load();
      },
      { rootMargin: '0px 0px 400px 0px' },
    );
    this.observer.observe(this);
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }

  async load() {
    try {
      const response = await fetch(this.dataset.url);
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const content = html.querySelector('product-recommendations [data-recommendations-content]');
      if (content && content.querySelector('[data-product-card]')) {
        this.querySelector('[data-recommendations-content]').replaceWith(content);
      } else {
        this.closest('.shopify-section')?.remove();
      }
    } catch {
      this.closest('.shopify-section')?.remove();
    }
  }
}

if (!customElements.get('product-recommendations')) customElements.define('product-recommendations', ProductRecommendations);
